import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

// APIS
// material
import {
  Box,
  Button,
  Card,
  Chip,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../../components/Iconify';
import { UserListHead } from '../../sections/@dashboard/user';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { courseTypes, paymentTypes, getDashboardBase } from '../../util/helpers';
import config from '../../util/config';
import DialogActions from '@mui/material/DialogActions';
import { Edit } from '@mui/icons-material';
import { createCourse, getFilteredCoursesAdmin, uploadCourseCoverPhoto } from '../../axiosLib/services/course/admin';
import { getAllInstitutions, adminLevel } from '../../axiosLib/services/institution/admin';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const TABLE_HEAD_COURSE = [
  { id: 'name', label: 'Course Title', alignRight: false },
  { id: 'code', label: 'Discounted Price', alignRight: false },
  { id: 'updatedAt', label: 'Duration', alignRight: false },
  { id: 'registered_at', label: 'Course Type', alignRight: false },
  { id: 'teachers', label: 'Course Teachers', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'paymentType', label: 'Payment Type', alignRight: false },
  { id: 'VIEW', label: 'VIEW', alignRight: false },
  { id: 'EDIT', label: 'EDIT', alignRight: false },
];

export default function CourseList() {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;

  const navigate = useNavigate();

  const [courseList, setCourseList] = useState([]);

  const [courseModal, setCourseModal] = useState(false);

  const [courseData, setCourseData] = useState({});

  const [activeStatus, setActiveStatus] = useState({});

  const [institutions, setInstitutions] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [hasCoursePage, setHasCoursePage] = useState(false);
  const fileInputRef = require('react').useRef(null);

  useEffect(() => {
    adminLevel((error, data) => {
      if (!error) {
        const roles = get(data, 'admin.institutionId.agencyWideRoles', []);
        setHasCoursePage(roles.includes('NEW_CLASSIC_EXAM_ADMIN_DASHBOARD'));
      }
    });
  }, []);

  const handleCourseEdit = (row) => {
    setCourseData(row);

    setCourseModal(true);
  };

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const allInstitutes = () => {
    getAllInstitutions((error, data) => {
      if (!error) {
        setInstitutions(data);
      } else {
        console.log(error);
      }
    });
  };

  const insetCourse = () => {
    createCourse(courseData, (error, data) => {
      if (!error) {
        // console.log(data);

        window.location.reload(false);
      } else {
        console.log(error);
      }
    });
  };

  const handleCourseDataChange = (fieldName, event) => {
    // console.log(event.target.value);
    setCourseData({ ...courseData, [fieldName]: event.target.value });
  };

  const handleCoverPhotoUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setUploading(true);
    uploadCourseCoverPhoto(file, (err, data) => {
      setUploading(false);
      if (!err && data && data.imageUrl) {
        setCourseData((prev) => ({ ...prev, image: data.imageUrl }));
      } else {
        alert('Upload failed: ' + (err || 'Unknown error'));
      }
    });
  };

  const deleteChip = (fieldName, chipToDelete) => {
    const values = get(courseData, fieldName, []);
    setCourseData({
      ...courseData,
      [fieldName]: values.filter((value) => {
        return value !== chipToDelete;
      }),
    });
  };

  const getName = (fieldName, idTOSearch) => {
    if (fieldName === 'sharedInstitution') {
      const selectedInstitutes = institutions.filter((institute) => {
        return institute._id.toString() === idTOSearch.toString();
      });

      return selectedInstitutes[0] ? selectedInstitutes[0].institutionName : null;
    }
  };

  const getCourses = () => {
    let temp = {
      status: activeStatus.status ?? 'Active',
    };

    try {
      getFilteredCoursesAdmin(temp, (error, data) => {
        if (!error) {
          setCourseList(get(data, 'courses', []));
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCourses();
    allInstitutes();
  }, []);

  useEffect(() => {
    getCourses();
  }, [activeStatus]);

  return (
    <Page title="Institute Details">
      <Container>
        {/* Course */}
        <Card>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
            <Typography
              variant="h4"
              gutterBottom
              style={{ marginLeft: 15, color: '#FF0000', backgroundColor: 'white' }}
            >
              All Available Course List
            </Typography>
            <FormControl fullWidth required style={{ width: '30%', marginLeft: 15, marginTop: '15px' }}>
              <InputLabel id="sessiom-label">Active Status</InputLabel>
              <Select
                id="active-status-label"
                defaultValue={get(activeStatus, 'status', 'Active')}
                label="Session"
                onChange={(e) => {
                  setActiveStatus({ ...activeStatus, ['status']: e.target.value });
                }}
              >
                {['Active', 'Not Active'].map((option) => (
                  <MenuItem value={option} key={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              style={{ marginRight: 10 }}
              variant="contained"
              component={RouterLink}
              to="#"
              startIcon={<Iconify icon="eva:plus-fill" />}
              onClick={() => handleCourseEdit({})}
            >
              Add New Course
            </Button>
          </Stack>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead headLabel={TABLE_HEAD_COURSE} rowCount={courseList.length} />
                <TableBody>
                  {courseList.map((row) => {
                    return (
                      <TableRow hover key={get(row, '_id', '')} tabIndex={-1}>
                        <TableCell align="left"> {get(row, 'title', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'discountedPrice', '0')}</TableCell>
                        <TableCell align="left"> {get(row, 'duration', '0')} Days</TableCell>
                        <TableCell align="left"> {get(row, 'type', '')} Days</TableCell>
                        <TableCell align="left"> {get(row, 'teachers', '')}</TableCell>
                        <TableCell align="left"> {get(row, 'publishType', 'Internal')}</TableCell>
                        <TableCell align="left"> {get(row, 'paymentType', '')}</TableCell>
                        <TableCell align="left">
                          {' '}
                          {get(row, 'isActive', true) ? (
                            <Button
                              variant="contained"
                              style={{
                                background: 'green',
                                color: '#fff',
                              }}
                            >
                              Active
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              style={{
                                background: 'red',
                                color: '#fff',
                              }}
                            >
                              Not Active
                            </Button>
                          )}
                        </TableCell>

                        <TableCell align="left">
                          <Stack direction="row" spacing={1}>
                            <Button
                              variant="contained"
                              component={RouterLink}
                              to={getDashboardBase() + '/courseDetailsAndEnrollments/?courseId=' + get(row, '_id')}
                            >
                              VIEW DETAILS
                            </Button>
                            {hasCoursePage && (
                              <Button
                                variant="outlined"
                                component={RouterLink}
                                to={getDashboardBase() + '/course-details?courseId=' + get(row, '_id')}
                                style={{ color: '#7b2ff7', borderColor: '#7b2ff7' }}
                              >
                                COURSE PAGE
                              </Button>
                            )}
                          </Stack>
                        </TableCell>
                        <TableCell align="left">
                          {' '}
                          {
                            <Button
                              variant="contained"
                              onClick={() => handleCourseEdit(row)}
                              style={{ color: '#880ED4', backgroundColor: 'white' }}
                            >
                              <Edit style={{ color: '#880ED4', marginRight: 5 }} /> EDIT
                            </Button>
                          }
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>

        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={10}>
          {' '}
        </Stack>

        {/* COURSE MODAL*/}
        <div>
          <Dialog open={courseModal} onClose={() => setCourseModal(false)} fullWidth={true}>
            <DialogTitle>Add/Edit Course</DialogTitle>

            {/* Cover photo preview at top */}
            {get(courseData, 'image', '') && get(courseData, 'image', '') !== '0' && (
              <Box sx={{ mx: 3, mb: 1, borderRadius: 2, overflow: 'hidden', border: '1px solid #e5e7eb', background: '#f8fafc' }}>
                <img
                  src={
                    get(courseData, 'image', '').startsWith('http')
                      ? get(courseData, 'image', '')
                      : config.BASE_API_URL + get(courseData, 'image', '')
                  }
                  alt="Cover Preview"
                  style={{ width: '100%', maxHeight: 200, objectFit: 'cover', display: 'block' }}
                  onError={(e) => { e.target.src = ''; e.target.alt = '⚠️ Image failed to load'; e.target.style.padding = '20px'; e.target.style.textAlign = 'center'; }}
                />
              </Box>
            )}

            <DialogContent>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2}>
                <TextField
                  name="name"
                  label="Course Title"
                  style={{ width: '100%' }}
                  value={get(courseData, 'title', '')}
                  onChange={(e) => {
                    handleCourseDataChange('title', e);
                  }}
                  required
                />
              </Stack>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2}>
                <TextField
                  name="subjectCode"
                  label="Description"
                  style={{ width: '100%' }}
                  value={get(courseData, 'description', '')}
                  onChange={(e) => {
                    handleCourseDataChange('description', e);
                  }}
                  required
                />
              </Stack>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2}>
                <TextField
                  name="c-m-price"
                  label="Main Price"
                  style={{ width: '100%' }}
                  value={get(courseData, 'price', '0')}
                  onChange={(e) => {
                    handleCourseDataChange('price', e);
                  }}
                  required
                />

                <TextField
                  name="subjectCode"
                  label="Discounted Price"
                  style={{ width: '100%' }}
                  value={get(courseData, 'discountedPrice', '0')}
                  onChange={(e) => {
                    handleCourseDataChange('discountedPrice', e);
                  }}
                  required
                />
              </Stack>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2}>
                <TextField
                  name="subjectCode"
                  label="Course Duration in Days"
                  style={{ width: '50%' }}
                  value={get(courseData, 'duration', '0')}
                  onChange={(e) => {
                    handleCourseDataChange('duration', e);
                  }}
                  required
                />

                <TextField
                  name="subjectCode"
                  label="Course Duration in Bangla"
                  style={{ width: '100%' }}
                  value={get(courseData, 'time', '0')}
                  onChange={(e) => {
                    handleCourseDataChange('time', e);
                  }}
                  required
                />
              </Stack>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2} alignItems="center">
                <TextField
                  name="coverPhoto"
                  label="Cover Photo Link"
                  style={{ width: '100%' }}
                  value={get(courseData, 'image', '')}
                  onChange={(e) => {
                    handleCourseDataChange('image', e);
                  }}
                />
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={handleCoverPhotoUpload}
                />
                <Button
                  variant="outlined"
                  onClick={() => fileInputRef.current && fileInputRef.current.click()}
                  disabled={uploading}
                  sx={{ minWidth: 140, height: 56, textTransform: 'none', fontWeight: 600 }}
                  startIcon={<Iconify icon={uploading ? 'mdi:loading' : 'mdi:cloud-upload'} />}
                >
                  {uploading ? 'Uploading...' : 'Upload Photo'}
                </Button>
              </Stack>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2}>
                <TextField
                  name="teachers"
                  label="Course Teachers"
                  style={{ width: '100%' }}
                  value={get(courseData, 'teachers', '')}
                  onChange={(e) => {
                    handleCourseDataChange('teachers', e);
                  }}
                  required
                />
              </Stack>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2}>
                <FormControl fullWidth required>
                  <InputLabel id="sessiom-label">Active</InputLabel>
                  <Select
                    id="session-label"
                    value={get(courseData, 'isActive', 'false')}
                    label="Publishd Course"
                    onChange={(e) => {
                      handleCourseDataChange('isActive', e);
                    }}
                  >
                    {['true', 'false'].map((option) => (
                      <MenuItem value={option} key={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth required>
                  <InputLabel id="Internal-sessiom-label">Publish Type</InputLabel>
                  <Select
                    id="Internal-session-label"
                    value={get(courseData, 'publishType', 'Internal')}
                    label="Publishd Course"
                    onChange={(e) => {
                      handleCourseDataChange('publishType', e);
                    }}
                  >
                    {['Internal', 'Public'].map((option) => (
                      <MenuItem value={option} key={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2}>
                <FormControl fullWidth required>
                  <InputLabel id="sessiom-label">Course Type</InputLabel>
                  <Select
                    id="c-type"
                    value={get(courseData, 'type', '')}
                    label="Course Type"
                    onChange={(e) => {
                      handleCourseDataChange('type', e);
                    }}
                  >
                    {courseTypes.map((option) => (
                      <MenuItem value={option} key={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth required style={{ width: '100%' }}>
                  <InputLabel id="isActive">Payment Type</InputLabel>
                  <Select
                    // labelId="session"
                    id="paymentTypes"
                    value={get(courseData, 'paymentType', paymentTypes[0])}
                    label="Active Status"
                    onChange={(e) => {
                      handleCourseDataChange('paymentType', e);
                    }}
                  >
                    {paymentTypes.map((option) => (
                      <MenuItem value={option} key={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} paddingBottom={2}>
                <FormControl fullWidth required>
                  <InputLabel id="sharedInstitution-l-level">Course is also available to:</InputLabel>
                  <Select
                    labelId="sharedInstitution-l-level"
                    id="sharedInstitution-level"
                    multiple
                    value={get(courseData, 'sharedInstitution', [])}
                    onChange={(e) => {
                      handleCourseDataChange('sharedInstitution', e);
                    }}
                    input={<OutlinedInput id="select-multiple-chip-sharedInstitution" label="Shared Institutions" />}
                    MenuProps={MenuProps}
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                          <Chip
                            key={value}
                            label={getName('sharedInstitution', value)}
                            onDelete={() => {
                              deleteChip('sharedInstitution', value);
                            }}
                            style={{ zIndex: 10000 }}
                          />
                        ))}
                      </Box>
                    )}
                  >
                    {institutions.map((institution) => (
                      <MenuItem key={institution._id} value={institution._id}>
                        {institution.institutionName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
            </DialogContent>

            <DialogActions>
              <Button variant="contained" onClick={insetCourse} style={{ color: 'white', backgroundColor: 'blue' }}>
                ADD / EDIT Course
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Container>
    </Page>
  );
}
